<template>
  <div class="container">
    <h1 class="heading">CVPA Class of 2026</h1>
    <div class="card mb-5">
      <div class="card-body">
        <b-img :src='"../assets/img/seniors/Group.jpg"' fluid></b-img>
      </div>
    </div>
    <p class="mb-4">Today, we celebrate the CVPA Class of 2026—a group of young adults who have grown with us, who have become a part of our family, and who have filled our studio with laughter, courage, and grace. The memories we've shared—every rehearsal, every late night, every moment of perseverance—will stay with us long after the curtains close.</p>
    <p class="mb-4">To Alexa Alejandre, Eva Barnezet Parrish, Alexa Barron, Alex Bland, Alexis Erickson, Mika Gomes, Kaylee Ho, Maggie Lei Chong, Chris Munoz, Adora Nzewi, Victoria Ortiz, Dayana Powe, Jenna Wong, and Emme Young: you arrived as hopeful dancers and have become so much more—friends, mentors, confidants, and a source of pride for us all. You faced the unprecedented with resilience, kindness, and a spirit that shines from the inside out. We have watched you listen deeply, work hard, and dream boldly, and in doing so, you have taught us as much as we have taught you.</p>
    <p class="mb-4">As you step into the next chapter, we hope you carry the warmth of this family in your hearts, the courage to follow your dreams, and the quiet confidence that you are deeply, forever loved. Remember that you are never alone—your dance family will always be here, cheering you on, ready to welcome you home no matter where your paths lead.</p>
    <p class="mb-4">With all our love, gratitude, and belief in your bright futures—congratulations, Class of 2026. You are now part of something enduring, and you will always be missed, always cherished, and always celebrated. Dream big, stay true to who you are, and know you carry our hearts with you wherever you go.</p>

    <div v-for="(item, index) in seniors" :key="item.Name" class="my-5">
      <Senior v-model="seniors[index]"></Senior>
    </div>
  </div>
</template>

<script>
import ProductService from "../services/ProductService";
import Senior from "../components/Senior";

export default {
  name: "Seniors",
  components: {
    Senior
  },
  async mounted() {
    this.seniors = (await ProductService.seniors()).sort((a, b) => { 
        var value1 = a.Name.toUpperCase();
        var value2 = b.Name.toUpperCase();
        if (value1 < value2) {
          return -1;
        }
        if (value1 > value2) {
          return 1;
        }
        return 0;
     });

    this.$nextTick(() => {
      setTimeout(() => {
        if (this.$route.hash) {
          const target = document.getElementById(this.$route.hash.substring(1));
          if (target) {
            target.scrollIntoView({ behavior: 'smooth' });
          }
        }
      }, 100);
    });
  },
  data() {
    return {
      seniors: []
    };
  },
  methods: {

  }
};
</script>
